import Swiper from "swiper/bundle";

import "swiper/css/bundle";

export default () => {
  const swiper01 = new Swiper(".swiper01", {
    slidesPerView: 1.2,
    spaceBetween: 10,
    centeredSlides: false,
    breakpoints: {
      768: {
          slidesPerView: 1.3,
          spaceBetween: 40,
          centeredSlides: false,
      },
    },
    pagination: {
      el: ".swiper01 .swiper-pagination01",
      clickable: true,
    },
  });

  const swiper02 = new Swiper(".swiper02", {
    slidesPerView: 1.3,
    spaceBetween: 20,
    centeredSlides: false,
    breakpoints: {
      768: {
          slidesPerView: 2.2,
          spaceBetween: 40,
          centeredSlides: false,
      },
    },
    pagination: {
      el: ".swiper02 .swiper-pagination02",
      clickable: true,
    },
  });

  const swiper03 = new Swiper(".swiper03", {
    slidesPerView: 1.3,
    centeredSlides: false,
    breakpoints: {
      768: {
          slidesPerView: 2.3,
          centeredSlides: false,
      },
    },
    pagination: {
      el: ".swiper03 .swiper-pagination03",
      clickable: true,
    },
  });

  const swiper04 = new Swiper(".swiper04", {
    slidesPerView: 1.3,
    spaceBetween: "20px",
    centeredSlides: false,
    breakpoints: {
      768: {
          slidesPerView: 2.3,
          centeredSlides: false,
      },
    },
  });

  const swiper05 = new Swiper(".swiper05", {
    slidesPerView: 1.5,
    spaceBetween: "20px",
    centeredSlides: false,
    breakpoints: {
      768: {
          slidesPerView: 2.3,
          centeredSlides: false,
      },
    },
    pagination: {
      el: ".swiper05 .swiper-pagination05",
      clickable: true,
    },
  });
}
